<template>
  <div>
    <div class="flex flex-row h-10 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest">
      <div class="self-center ml-4 text-sm font-semibold text-grey-darkest">Summary</div>
    </div>

    <!--core main-->
    <div class="flex flex-col overflow-y-auto pb-6" style="height: calc(100vh - 8rem)">
      <div class="flex flex-row bg-white px-2 py-4 mb-3 flex-no-shrink flex-no-grow border-solid border-b border-grey-lighest">
        <TextField label="Chief Complaint" fieldId="chief_compliant" :value="chiefComplaint" @saveChange="saveChange" />
      </div>

      <div class="relative flex flex-row px-2 py-4 mb-3 bg-white flex-no-shrink flex-no-grow border-solid border-b border-t border-grey-lighest">
        <auto-complete @input="getCodes($event)" :list="idc_codes" label="Diagnosis" fieldId="provisional_diagnois" :value="provisionalDiagnosis" @saveChange="saveChange"  :error="error"/>
      </div>

      <div class="flex flex-row bg-white px-2 py-4 mb-3 flex-no-shrink flex-no-grow border-solid border-b border-t border-grey-lighest">
        <TextField label="Summary" fieldId="summary_notes" :value="summaryNotes" @saveChange="saveChange" :error="error"/>
      </div>

       <!-- FOLLOW UPS -->
      <div v-if="activeSection === 'consults' && customer.consultation.consultationId">
        <div class="flex"></div>
          <!-- SCHEDULED FOLLOW UPS -->
          <scheduled-follow-up />
          <!-- SET FOLLOW UPS -->
          <set-up-follow-up :consultType="$attrs.chatType"/>
        </div>
      </div>  

    <!--footer-->
    <div v-if="activeSection === 'consults'" class="fixed pin-b flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow" v-bind:style="$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);'">
      <div class="flex flex-row mx-auto">
        <div v-if="!caseClosed" v-on:click="sendSummary()" class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 text-sm px-4 cursor-pointer">
          <span v-if="loader.loading && loader.componentKey === 'CS-SendSummary'">
            <button class="buttonload" style="color: white;">
              <i class="mr-2 fa fa-spinner fa-spin"></i> Loading
            </button>
          </span>
          <span class="text-sm font-semibold" v-else>Send Summary</span>
        </div>
        <div v-if="caseClosed" class="self-center bg-green p-2 rounded text-white font-light ml-2 text-sm font-semibold px-4">Case closed</div>
      </div>
    </div>
    <div v-if="showSaveReminder">
      <SummaryNotSavedModal @close='closeModal'/>
    </div>
  </div>
</template>

<script>
import TextField from '@/components/common/TextField'
import AutoComplete from '@/components/common/Autocomplete'
import ScheduledFollowUp from '@/components/Customer/FollowUp/Scheduled'
import SetUpFollowUp from '@/components/Customer/FollowUp/SetUp'
import {mapGetters, mapState} from 'vuex'
import SummaryNotSavedModal from '@/components/common/modals/SummaryNotSaved'
export default {
  components: {
    AutoComplete,
    TextField,
    ScheduledFollowUp,
    SetUpFollowUp,
    SummaryNotSavedModal
  },
  props: ['currentProps'],
  data () {
    return {
      search: '',
      idc_codes: [],
      showSaveReminder: false,
      error: {hasError: false, message: ''}
    }
  },
  computed: {
    ...mapState({
      editTextField: state => state.textField.inEdit,
      editTextFieldId: state => state.textField.field
    }),
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      loader: 'loader/getLoaderData',
      activeSection: 'configuration/getActiveSection'
    }),
    chiefComplaint: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.chiefComplaint) {
        this.error = { hasError: false, message: '' }
        return this.customer.consultation.chiefComplaint
      } else this.error = { hasError: true, message: 'You must add the chief complaint first' }
    },
    provisionalDiagnosis: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.provisionalDiagnosis) {
        return this.customer.consultation.provisionalDiagnosis
      }
    },
    summaryNotes: function () {
      if (this.customer && this.customer.consultation && this.customer.consultation.summaryNotes) {
        return this.customer.consultation.summaryNotes
      }
    },
    caseClosed: function () {
      if ((this.customer && (this.customer.consultation.summary_status === 'done' || this.customer.consultation.summary_status === 'not_needed')) || (this.customer && (this.customer.consultation.consultationId === null || this.customer.consultation.consultationId === undefined))) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    scheduledRerender: function () {
      this.scheduledKey += 1
      this.followUpKey += 1
    },
    closeModal: function () {
      this.showSaveReminder = false
    },
    getCodes: function (search) {
      if (search !== '') {
        var vm = this
        vm.$http.get(window.API_URL + 'doctors/icd_ten_codes?term=' + search)
        .then(response => {
          vm.idc_codes = response && response.body && response.body.length > 0 ? response.body : []
          vm.idc_codes.unshift(search)
        })
      }
    },
    saveChange: function (data) {
      if (this.$attrs.chatType === 'offline') {
        this.saveOfflineConsult(data)
      } else if (this.$attrs.chatType === 'online') {
        this.saveOnlineConsult(data)
      }
    },
    saveOfflineConsult: function (data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/updateConsultation', data)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/updateConsultation', data)
      }
    },
    saveOnlineConsult: function (data) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/updateConsultation', data)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/updateConsultation', data)
      }
    },

    sendSummary: function (data = {}) {
      data.componentKey = 'CS-SendSummary'
      if (this.$attrs.chatType === 'offline') {
        if (this.activeSection === 'consults') {
          if (this.editTextField && this.editTextFieldId === 'summary_notes') {
            this.showSaveReminder = true
            return
          }
          this.$store.dispatch('pastOfflineConsultation/sendSummary', data)
        }
      } else if (this.$attrs.chatType === 'online') {
        if (this.activeSection === 'connected') {
          this.$store.dispatch('consultation/sendSummary', data)
        } else if (this.activeSection === 'consults') {
          if (this.editTextField && this.editTextFieldId === 'summary_notes') {
            this.showSaveReminder = true
            return
          }
          this.$store.dispatch('pastConsultation/sendSummary', data)
        }
      }
    },
    summaryNotNeeded: function () {
      if (this.$attrs.chatType === 'offline') {
        if (this.activeSection === 'consults') {
          this.$store.dispatch('pastOfflineConsultation/summaryNotNeeded', {summary: 'NA', componentKey: 'CS-SummaryNotNeeded'})
        }
      } else if (this.$attrs.chatType === 'online') {
        if (this.activeSection === 'connected') {
          this.$store.dispatch('consultation/summaryNotNeeded', {summary: 'NA', componentKey: 'CS-SummaryNotNeeded'})
        } else if (this.activeSection === 'consults') {
          this.$store.dispatch('pastConsultation/summaryNotNeeded', {summary: 'NA', componentKey: 'CS-SummaryNotNeeded'})
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Customer/ConsultationSummary.vue